import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  MODE_CPU,
  MODE_MULTIPLAYER,
  setSelectedGameMode,
} from "../../game/gameModeStorage";
import "./modes.css";

const LOGO_SRC = `${process.env.PUBLIC_URL}/img/game-logo.png`;
const COMPUTER_SRC = `${process.env.PUBLIC_URL}/img/computer.png`;
const MULTIPLAYER_SRC = `${process.env.PUBLIC_URL}/img/multiplayer.png`;

/** Multiplayer is hidden for now; flip to true to bring it back. */
const SHOW_MULTIPLAYER = false;

function Modes() {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("modes-static-bg");
    document.body.classList.add("modes-static-bg");
    return () => {
      document.documentElement.classList.remove("modes-static-bg");
      document.body.classList.remove("modes-static-bg");
    };
  }, []);

  const pickCpu = () => {
    setSelectedGameMode(MODE_CPU);
    navigate("/rules");
  };

  const pickMultiplayer = () => {
    setSelectedGameMode(MODE_MULTIPLAYER);
    navigate("/lobby", { replace: true });
  };

  return (
    <div className="modes-page">
      <img
        className="modes-logo"
        src={LOGO_SRC}
        alt="Connect 4 Showdown"
      />
      <div className="modes-row">
        <button
          type="button"
          className="modes-choice-btn"
          onClick={pickCpu}
          aria-label="Play vs computer"
        >
          <img
            className="modes-choice"
            src={COMPUTER_SRC}
            alt=""
          />
        </button>
        {SHOW_MULTIPLAYER ? (
          <button
            type="button"
            className="modes-choice-btn"
            onClick={pickMultiplayer}
            aria-label="Play multiplayer"
          >
            <img
              className="modes-choice"
              src={MULTIPLAYER_SRC}
              alt=""
            />
          </button>
        ) : null}
      </div>

    </div>
  );
}

export default Modes;
